/**
 * Enable legacy web implementation for React Native Gesture Handler
 * This is required for proper functionality of react-native-reanimated-carousel on web
 * For more details, see: https://docs.swmansion.com/react-native-gesture-handler/docs/fundamentals/installation/#web
 */

import { AppRegistry } from 'react-native';
import { enableLegacyWebImplementation } from 'react-native-gesture-handler';
import AntDesignIcons from 'react-native-vector-icons/Fonts/AntDesign.ttf';
import FeatherIcons from 'react-native-vector-icons/Fonts/Feather.ttf';
import FAIcons from 'react-native-vector-icons/Fonts/FontAwesome.ttf';
import Ionicons from 'react-native-vector-icons/Fonts/Ionicons.ttf';
import MaterialIcons from 'react-native-vector-icons/Fonts/MaterialIcons.ttf';

import { name as appName } from './app.json';
import MobileWebRoot from './src/index.web';

enableLegacyWebImplementation(true);

const IconFontStyles = `@font-face {
  src: url(${AntDesignIcons});
  font-family: AntDesign;
}
@font-face {
  src: url(${Ionicons});
  font-family: Ionicons;
}
@font-face {
  src: url(${FAIcons});
  font-family: FontAwesome;
}
@font-face {
  src: url(${FeatherIcons});
  font-family: Feather;
}
@font-face {
  src: url(${MaterialIcons});
  font-family: MaterialIcons;
}
`;

const style = document.createElement('style');
style.appendChild(document.createTextNode(IconFontStyles));

document.head.appendChild(style);

AppRegistry.registerComponent(appName, () => MobileWebRoot);

AppRegistry.runApplication(appName, {
  rootTag: document.getElementById('root')
});
